<template>
<div class="s-role">
    <a-checkbox-group v-model="selected" @change="informParent">
      <a-checkbox v-for="(role,id) in this.data"
      :key="id"
      :value="role.id">
        {{role.name}}
      </a-checkbox>
    </a-checkbox-group>
</div>
</template>

<script>
export default {
  name: 'RoleComp',
  props: {
    data: { type: Array, required: true },
    selectedRoles: { type: Array },
  },
  data: function() {
    return {
      selected: [],
    }
  },
  watch: {
    selectedRoles(newvalue, oldvalue) {
      this.selected = []
      this.selected.length = 0
      newvalue.forEach(element => {
        this.selected.push(element.id)
      })
    },
  },
  methods: {
    // onSelect() {
    //   this.$emit('onSelect', this.selected)
    // },
    informParent() {
      this.$emit('onSelect', this.selected)
    },
    onChange: function () {
      // console.log(`${e.target.checked}`)
      // console.dir(e)
      // var item = e.target.value
      // if (e.target.checked) {
      //   this.selected.push(item)
      // } else {
      //   var itemindex = this.selected.indexOf(item)
      //   this.selected.splice(itemindex, 1)
      // }
      // // console.log(this.selected)
      // // return this.selected

      // this.$emit('onSelect', this.selected)
    },
  },
}
</script>

<style>
.s-role {
  margin-bottom: 35px;
}
</style>
